import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAuthToken } from '../../Utils/auth.ts';
let isUnauthorizedHandled = false;
let isServerErrorHandled = false;
const handleUnauthorized = () => {
  if (isUnauthorizedHandled) return;
  isUnauthorizedHandled = true;

  localStorage.clear();
  toast.error("Login Expired.");

  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage('logout');
  }
};

const handleServerError = () => {
  if (isServerErrorHandled) return;
  isServerErrorHandled = true;
  toast.error("Server Error");
};

export const getStops= (
  vehicle_id:any,
  per_page_records: any,
  page_number: any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
) => {

  axios
    .get(`${global.stms_url}/api/vehicle_stops?vehicle_id=${vehicle_id}&page_number=${page_number}&per_page_records=${per_page_records}` )
    .then((response: AxiosResponse) => {
      if (response.status === 200 || response.status === 201) {
        _successCallBack(response.data);
      }
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 400 || error.response?.status === 404) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
            handleUnauthorized();
      } else {
        handleServerError();
        _errorCallBack(error);
      }
    });
};
 export const editStops = (
    status: string | null,
    name: string | null,
    geofence_id: string|null,  
    vehicle_id: string | null,
    lat: string | null,
    lng: string | null,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
  ) => {
    const payload = {
      status,
      name,
      vehicle_id,
      lat,
      lng
    };
    axios
      .put(`${global.stms_url}/api/vehicle_stops/${geofence_id} `, payload)
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data); 
        }
        else if(response.status === 201) {
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data); 
        } 
        else if (error.response?.status === 404) {
          _errorCallBack(error.response.data);
        }else if  (error.response?.status === 401){
          handleUnauthorized();
        }
        else{
          handleServerError();
        }
      });
  };
    export const addStops = (companies_id:any,name:any,vehicle_id:any,lat:any,lng:any,radius_meters:any,
      _successCallBack: (response: any) => void,
      _errorCallBack: (errMessage: any) => void
      ) => {
        const payload = {
          companies_id,
          name,
          vehicle_id,lat,lng,radius_meters
        };
      axios
        .post(`${global.stms_url}/api/vehicle_stops`, payload, )
        
        .then((response: AxiosResponse) => {
          if (response.status === 200 || response.status === 201) {
            _successCallBack(response.data);
          } else {
            _errorCallBack("Unexpected status code: " + response.status);
          }
        })
        .catch((error: AxiosError) => {
            console.log('Error caught:', error);
            if (error.response?.status === 400) {
              _errorCallBack(error.response.data);
            } else if (error.response?.status === 404) {
                console.log(error.response.data);
              _errorCallBack(error.response.data);
            }else if (error.response?.status === 401) {
              localStorage.clear();
            } 
          });
    };
    export const deleteSTMSStops = (
    geofence_id: string|null,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    company_id?: string | null
  ) => {

    const data = {
     geofence_id : geofence_id
    };
    axios
      .delete(`${global.stms_url}/api/vehicle_stops/${geofence_id}`, {
         params: {
                company_id: company_id
            }

      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 200) {
          _successCallBack(response.data);
        } 
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        } else if (error.response?.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        }  else if( error.response?.status === 404)
          {
            _errorCallBack(error?.response?.data);
          }
        else {
          toast.error("Server Error");
        }
      });
  };